<template>
    <div class="container">
        <div class="search" style="display:flex">
            <el-form ref="formRef" style="flex:1" :inline="true" :model="form" class="demo-form-inline" size="mini">
                <el-form-item label="商户CODE：" prop="partner_code">
                    <el-input v-model.trim="form.partner_code" placeholder=" " @keyup.enter="onSearch"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" style="margin-left: 16px;" class="btnClass"
                        @click="onSearch">搜索</el-button>
                    <el-button type="text" class="textBtn" style="padding-bottom: 0px;vertical-align: bottom;"
                        @click="resetForm(formRef)">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-table :data="list" size="mini">
            <el-table-column label="商户CODE">
                <template v-slot="scope">
                    <span>{{ scope.row.partner_code }}</span>
                </template>
            </el-table-column>
            <el-table-column label="企业名称">
                <template v-slot="scope">
                    <span>{{ scope.row.partner_name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="可提现金额">
                <template v-slot="scope">
                    <span>{{ scope.row.amount_cny }}</span>
                </template>
            </el-table-column>
            <el-table-column label="相机激活补贴金额(累计)" width="180">
                <template v-slot="scope">
                    <span>{{ scope.row.device_activation_amount_cny }}</span>
                </template>
            </el-table-column>
            <el-table-column label="相机生产补贴金额(累计)" width="180">
                <template v-slot="scope">
                    <span>{{ scope.row.device_factory_amount_cny }}</span>
                </template>
            </el-table-column>
            <el-table-column label="提取中的金额">
                <template v-slot="scope">
                    <span>{{ scope.row.frozen_amount_cny }}</span>
                </template>
            </el-table-column>
            <el-table-column label="云存收入佣金(累计)">
                <template v-slot="scope">
                    <span>{{ scope.row.order_commission_cny }}</span>
                </template>
            </el-table-column>
            <el-table-column label="待结算金额">
                <template v-slot="scope">
                    <span>{{ scope.row.unsettled_amount_cny }}</span>
                </template>
            </el-table-column>
            <el-table-column label="已经提取的金额(累计)">
                <template v-slot="scope">
                    <span>{{ scope.row.withdrawn_amount_cny }}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template v-slot="scope">
                    <router-link :to="`/salespartner/fundsaccount/detail/${scope.row.partner_code}`">
                        <el-button type="primary" size="mini" class="btnClass">详情</el-button>
                    </router-link>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" v-model:currentPage="pagination.page"
            :page-size="pagination.limit" layout="total, prev, pager, next" :total="pagination.total" background>
        </el-pagination>
    </div>
</template>

<script>
import { onMounted, reactive, ref, toRaw } from 'vue'
import { ElMessage } from 'element-plus'
import { useRouter } from 'vue-router'
import util from '../../../util/util'
import api from '../../../axios/api'

export default {
    setup() {
        const router = useRouter()
        const form = reactive({
            partner_code: ''
        })
        const pagination = reactive({
            page: 1,
            limit: 16,
            total: 0
        })
        const formRef = ref()
        const list = ref([])

        const handleCurrentChange = (val) => {
            pagination.page = val
            onSearch()
        }

        const onSearch = async () => {
            const res = await api.SalesPartnerFundsAccountList({
                ...toRaw(form),
                page: pagination.page,
                limit: pagination.limit
            })
            if (res.data.code === 200) {
                const { data, page_info } = res.data.data
                list.value = data
                pagination.total = page_info.total
            } else {
                ElMessage.error('查询失败: ' + res.msg)
            }
        }

        const add = () => {
            router.push('/salespartner/list/add/0')
        }

        const resetForm = (formEl) => {
            if (!formEl) return
            formEl.resetFields()
            onSearch()
        }

        onMounted(() => {
            onSearch()
        })

        return {
            form,
            onSearch,
            list,
            formRef,
            pagination,
            handleCurrentChange,
            add,
            resetForm,
            util
        }
    }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.container {
	font-family: 'Manrope';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	.search {
		background: #F0F2F5;
		padding-top: 16px;
		margin-bottom: 24px;
	}
	.el-form {
		::v-deep(.el-form-item__label) {
			font-family: 'Manrope';
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: #000000;
            opacity: 0.8;
			padding-right: 0px;
		}
		.el-form-item {
			margin-left: 24px;
		}
	}
	.btnClass {
		color: #FFF;
		background-color: #FB6D07;
		border-color: #FB6D07;
	}
	.textBtn {
		color: #FB6D07;
	}
	::v-deep(thead) {
		font-family: 'Manrope';
		font-style: normal;
		font-weight: 400;
		font-size: 14px;
		color: #000;
		opacity: 0.8;
		th {
			font-weight: 400;
			background-color: #F0F2F5;
		}
	}
  ::v-deep(tbody) {
    tr {
      font-family: 'Manrope';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      opacity: 0.8;
    }
  }

}
</style>
